import React from "react";
import PropTypes from "prop-types";
import log from "../../helpers/log";
class FlashRequest extends React.Component {
	constructor(props) {
		super(props);
		this.state = { showArrow: false, loading: true };
		this.checkFlash = this.checkFlash.bind(this);
		this.activarFlash = this.activarFlash.bind(this);
		this.nextStep = this.nextStep.bind(this);
		this.waitForLoad = this.waitForLoad.bind(this);
		this.checkExtension = this.checkExtension.bind(this);
		this.state = {
			interval: null
		};
	}
	componentDidMount() {
		this.checkFlash();
	}
	waitForLoad() {
		if (window.chrome !== undefined) {
			this.setState({
				loading: false
			});
			this.checkExtension();
		} else {
			if (document.readyState !== "complete") {
				document.onreadystatechange = () => {
					if (document.readyState === "complete") {
						this.setState({
							loading: false
						});
					}
				};
			} else {
				this.setState({
					loading: false
				});
			}
		}
	}
	checkExtension() {
		let extensionId = "fdkgolkkimdnnjaeiogdciekaflaellb";
		const host = window.location.host;
		if (host.includes("jogosjogos")) {
			extensionId = "plhdffccclnkdlolokgfdobocldbjdjn";
		} else if (host.includes("pomu")) {
			extensionId = "njbfimohacanhjdokmpagpaaadkkmhkh";
		}
		log(__filename, `Checking ${extensionId}`);
		const finalUrl = window.location.host.split(".");

		try {
			chrome.runtime.sendMessage(
				extensionId,
				{
					message: "version",
					url:
						finalUrl[finalUrl.length - 2] + "." + finalUrl[finalUrl.length - 1]
				},
				reply => {
					if (reply) {
						//alert("Reply");
						this.nextStep();
						//window.location.reload();
					} else {
						setTimeout(this.checkExtension, 500);
					}
				}
			);
		} catch (error) {
			setTimeout(this.checkExtension, 500);
		}
	}
	checkFlash() {
		try {
			let flash = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
			if (flash) {
				this.nextStep();
			} else {
				this.waitForLoad();
			}
		} catch (e) {
			if (
				this.props.navigator.mimeTypes["application/x-shockwave-flash"] !=
				undefined
			) {
				this.nextStep();
			} else {
				this.waitForLoad();
			}
		}
	}
	activarFlash() {
		this.setState({ showArrow: true });
	}
	// Llamamos a la función que nos indiquen ()
	nextStep() {
		this.props.callback();
	}
	render() {
		const host = window.location.host;
		const { translate } = this.props;
		if (window.chrome !== undefined) {
			let extensionUrl =
				"https://chrome.google.com/webstore/detail/juegosjuegos/fdkgolkkimdnnjaeiogdciekaflaellb";
			if (host.includes("jogosjogos")) {
				extensionUrl =
					"https://chrome.google.com/webstore/detail/jogosjogos/plhdffccclnkdlolokgfdobocldbjdjn";
			} else if (host.includes("pomu")) {
				extensionUrl =
					"https://chrome.google.com/webstore/detail/pomu/njbfimohacanhjdokmpagpaaadkkmhkh";
			}
			return (
				<div className="flashRequest ">
					<div className="overlay chrome">
						<div
							className="background"
							style={{
								backgroundImage: `url(${this.props.background})`,
								backgroundPosition: "center",
								backgroundSize: "cover",
								backgroundRepeat: "no-repeat"
							}}
						/>
						<img
							src="/public/images/common/logo_activar_flash.png"
							alt={this.props.translate.activar_flash}
						/>
						<div className="description">
							{translate.install_extension_body}
							<a
								href={extensionUrl}
								className="btn btn-activar chrome"
								target="_blank"
							>
								<i className="fa fa-chrome" />{" "}
								{translate.install_extension_button}
							</a>
						</div>
					</div>
				</div>
			);
		}
		return (
			<div className="flashRequest" onMouseDown={this.activarFlash}>
				<object
					id="flash-box"
					width="100%"
					height="100%"
					type="application/x-shockwave-flash"
					data="/public/swf/flashload-fixer.swf"
				>
					<param name="movie" value="/public/swf/flashload-fixer.swf" />
					<param name="allowScriptAccess" value="always" />
					<param name="allowNetworking" value="all" />
					<param name="wmode" value="transparent" />
					<param name="wmode" value="direct" />
					<param name="bgcolor" value="#FFFFFF" />
					<embed
						name="flash_object_embed"
						src="/public/swf/flashload-fixer.swf"
						width="100%"
						height="600"
						type="application/x-shockwave-flash"
						allowscriptaccess="always"
						align="middle"
						allownetworking="internal"
						wmode="direct"
						bgcolor="#FFFFFF"
					/>
				</object>
				<div className="overlay">
					<div
						className="background"
						style={{
							backgroundImage: `url(${this.props.background})`,
							backgroundPosition: "center",
							backgroundSize: "cover",
							backgroundRepeat: "no-repeat"
						}}
					/>
					<img
						src="/public/images/common/logo_activar_flash.png"
						alt={this.props.translate.activar_flash}
					/>
					<button className="btn btn-activar">
						{this.state.loading ? (
							<i className="fa fa-spin fa-spinner" />
						) : (
							this.props.translate.activar_flash
						)}
					</button>
				</div>
				{this.state.showArrow ? (
					<div className="flecha">
						<img src="/public/images/common/green_arrow.png" alt="Click Here" />
					</div>
				) : null}
			</div>
		);
	}
}
FlashRequest.propTypes = {
	translate: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	background: PropTypes.string.isRequired,
	navigator: PropTypes.object.isRequired,
	callback: PropTypes.func.isRequired
};
FlashRequest.defaultProps = {
	translate: {
		activar_flash: "Activar Adoble Flash Player"
	}
};
export default FlashRequest;
